// --------------------------------------------------------------------------------------------
// #MOBILE TESTIMONIAL
// --------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------
// #MOBILE TESTIMONIAL LOAD MORE (<= 575px)
// --------------------------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const MOBILE_BREAKPOINT = 575;

  const section = document.querySelector(".testimonials-grid");
  if (!section) return;

  const loadMoreButton = section.querySelector(".js-loadMore");
  const items = section.querySelectorAll(".js-testimonial-load-more-item");

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function setupTestimonials() {
    if (!loadMoreButton || !items.length) return;

    if (isMobile()) {      
      items.forEach((item, index) => {
        item.style.display = index < 2 ? "block" : "none";
      });

      loadMoreButton.style.display = "block";
      loadMoreButton.classList.remove("no-testimonials");
    } else {    
      items.forEach(item => {
        item.style.display = "block";
      });

      loadMoreButton.style.display = "none";
    }
  }

  loadMoreButton.addEventListener("click", function (e) {
    e.preventDefault();
    if (!isMobile()) return;

    const hiddenItems = Array.from(items).filter(
      item => window.getComputedStyle(item).display === "none"
    );

    hiddenItems.slice(0, 3).forEach(item => {
      item.style.display = "block";
    });
   
    const stillHidden = Array.from(items).some(
      item => window.getComputedStyle(item).display === "none"
    );

    if (!stillHidden) {
      loadMoreButton.classList.add("no-testimonials");
      loadMoreButton.style.display = "none";
    }
  });

  setupTestimonials();
  
  window.addEventListener("resize", setupTestimonials);
});
